import { SectionFragment } from '__generated__/queries-newsletter';
import { EditorState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { isEmpty, isString } from 'lodash';
import { paths, replaceParams } from 'routing';
import { CreateSections } from '../ContentPage/utils/emptyTypes';

const getContentStateToHTML = (content: string | null | undefined) =>
  content
    ? stateToHTML(((content as unknown) as EditorState).getCurrentContent())
    : null;

export const computePreviewUrl = (linkUrl: string, campaignId: number) =>
  `${linkUrl}?campaignId=${campaignId}`;

export const computeCampaignRssUrl = (
  linkUrl: string,
  templateId: number,
  campaignId: number,
) => `${linkUrl}/newsletters/${templateId}/campaign?campaignId=${campaignId}`;

const removeValidatorFromState = (campaignItem: any) => {
  // eslint-disable-next-line immutable/no-mutation
  campaignItem.sections = campaignItem.sections.map(
    (section: SectionFragment, index: number) => {
      // eslint-disable-next-line immutable/no-mutation
      campaignItem.sections[index].blocks = section.blocks.map((block: any) => {
        // eslint-disable-next-line fp/no-delete
        delete block.urlInError;
        // eslint-disable-next-line fp/no-delete
        delete block.urlInErrorMessage;

        return block;
      });

      return section;
    },
  );

  return campaignItem;
};

export const transformItem = (
  campaignItem: any,
  idsOfCreatedBlocksAndSections: Set<string>,
) => {
  if (isEmpty(campaignItem)) {
    return campaignItem;
  }

  const medias = campaignItem.medias?.length ? campaignItem.medias : null;
  // eslint-disable-next-line fp/no-delete
  delete campaignItem.medias;

  // eslint-disable-next-line no-param-reassign
  campaignItem = removeValidatorFromState(campaignItem);

  return {
    ...campaignItem,
    rawMedias: medias ? JSON.stringify(medias) : null,
    sections: campaignItem.sections.map(
      ({ maxBlocksAmount, ...rest }: CreateSections) => {
        return {
          ...rest,
          isCreate: !idsOfCreatedBlocksAndSections.has(rest.id),
          title: isString(rest.title)
            ? rest.title
            : getContentStateToHTML(rest.title),
          blocks: rest.blocks.map((block) => ({
            ...block,
            content: isString(block.content)
              ? block.content
              : getContentStateToHTML(block.content),
            isCreate: !idsOfCreatedBlocksAndSections.has(block.id),
            linkLabel: isString(block.linkLabel)
              ? block.linkLabel
              : getContentStateToHTML(block.linkLabel),
            rawMedia: block.media ? JSON.stringify(block.media) : null,
            surTitle: isString(block.surTitle)
              ? block.surTitle
              : getContentStateToHTML(block.surTitle),
            title: isString(block.title)
              ? block.title
              : getContentStateToHTML(block.title),
          })),
        };
      },
    ),
  };
};

export const getUnlockLink = (id: string) =>
  `${window.location.origin}${replaceParams(paths.CAMPAIGN_UNLOCK, {
    id,
  })}`;
